module.exports = "\n<div class=\"form_wizard wizard_horizontal\">\n\n    <ng-content select=\".wizard-top-content\"></ng-content>\n\n    <ul *ngIf=\"!navigationBarHidden\" class=\"wizard_steps\">\n        <ng-content select=\"wizard-tab\"></ng-content>\n    </ul>\n\n    <div class=\"content-container\">\n        <ng-content select=\"wizard-content\"></ng-content>\n    </div>\n\n    <ng-content select=\".wizard-bottom-content\"></ng-content>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/wizard/wizard.template.html
// module id = 932
// module chunks = 0